export const manageIdeas = {
    title: "Manage Ideas",
    subtitle: "manage your ideas"
}

export const noIdeas = "You haven`t created any ideas yet, please click on the + icon below to start evaluating";